class Toggle extends React.Component {

    render() {
    	var self       = this;

    	var value      = this.props.value;
    	var required   = this.props.required;

    	var checked    = value === required ? true : false;

        return (
            <div 
            	className={'toggle '+(checked ? 'toggle__'+this.props.type : '')+' '+this.props.className}
            	onClick={() => { self.props.onClick(); }}>

            	<div className='toggle__label'>
                	{this.props.label}
                </div>
            </div>
        );

    }
}

export default Toggle;


// WEBPACK FOOTER //
// ./ui_src/app/components/form/Toggle.react.jsx